<div class="p-grid">
    <form *ngIf="formData.controls.country && formData.controls.cityNewRouting && formData.controls.company" [formGroup]="formData" class="p-md-7 p-col-12">
        <div class="mu-input-form-container p-grid">
            <app-mu-form-fieldset>
                <div class="mu-formGroup-container">
                    <h3 class="mu-routing-searchForm-title">{{ 'context.massive.newRouting.routingsearchForm.labels.selectCountry' | translate}}</h3>
                    <app-mu-form-dropdown 
                    [formGroup]="formData"
                    field="country" 
                    [optionList]="coutriesListInput"
                    >
                    </app-mu-form-dropdown>
                </div>
            </app-mu-form-fieldset>
        </div>
        <div class="mu-input-form-container p-grid">
            <app-mu-form-fieldset>
                <div class="mu-formGroup-container">
                    <h3 class="mu-routing-searchForm-title">{{ 'context.massive.newRouting.routingsearchForm.labels.selectCity' | translate}}</h3>
                    <app-mu-form-dropdown 
                    [formGroup]="formData"
                    field="cityNewRouting" 
                    [optionList]="citiesListInput"
                    >
                    </app-mu-form-dropdown>
                </div>
            </app-mu-form-fieldset>
            <app-mu-form-fieldset>
                <div class="mu-formGroup-container">
                    <h3 class="mu-routing-searchForm-title">{{ 'context.massive.newRouting.routingsearchForm.labels.selectCompany' | translate}}</h3>
                    <app-mu-form-dropdown 
                        [formGroup]="formData"
                        field="company" 
                        [optionList]="companiesListInput"
                        >
                    </app-mu-form-dropdown>
                </div>
            </app-mu-form-fieldset>
        </div>
        <div class="mu-input-form-container p-grid">
            <app-mu-form-fieldset>
                <div class="mu-formGroup-container">
                    <h3 class="mu-routing-searchForm-title">{{ 'context.massive.newRouting.routingsearchForm.labels.cedi' | translate}}</h3>
                    <app-mu-form-dropdown 
                        [formGroup]="formData"
                        field="cediPoint" 
                        [optionList]="cediPointsListInput"
                        >
                    </app-mu-form-dropdown>
                </div>
            </app-mu-form-fieldset>
            <app-mu-form-fieldset>
                <div class="mu-formGroup-container">
                    <div class="mu-dropdown-container">
                        <app-mu-button 
                            [flagList]="flagList"
                            [flag]="showCreateCediFlag"
                            [label]="'context.massive.newRouting.routingsearchForm.buttons.createCedi' | translate"
                            [icon]="'fa-plus'"
                            [disabled]="!formData.controls.country.valid || !formData.controls.cityNewRouting.valid || !formData.controls.company.valid"
                            >
                        </app-mu-button>
                    </div>
                </div>
            </app-mu-form-fieldset>
        </div>
        <div class="p-grid">
            <app-mu-button 
                [label]="'context.massive.newRouting.routingsearchForm.buttons.continue' | translate"
                [flagList]="flagList"
                [flag]="continueToDeliveries"
                [disabled]="!formData.valid"
                class="p-md-6 p-col-12 p-p-0 p-m-0"
                >
            </app-mu-button>
        </div>
    </form>
</div> 